import { render } from "./ExpertRichResources.vue?vue&type=template&id=9a977c60&scoped=true"
import script from "./ExpertRichResources.vue?vue&type=script&lang=js"
export * from "./ExpertRichResources.vue?vue&type=script&lang=js"

import "./ExpertRichResources.vue?vue&type=style&index=0&id=9a977c60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a977c60"]])

export default __exports__